import { MatSelectChange } from '@angular/material/select';
import { Component, ViewChild, OnInit, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, PLATFORM_ID, Inject, Renderer2, LOCALE_ID, DEFAULT_CURRENCY_CODE, ElementRef, ViewContainerRef } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { OfferService } from './offer.service';
import { Product, ProductVariant, ProductPhoto, Collection, dimensionUnits } from './offer.model';
import { NavigationService } from '../shared/navigation/navigation.service';
import { UtilsService } from '../shared/services/utils.service';
import { CartService } from '../shared/cart/cart.service';
import { Discount } from '../shared/cart/cart.model';
import { AuthService, UserState } from '../shared/auth/auth.service';
import { environment } from '../../environments/environment';
import { BehaviorSubject, Subject, Subscription, interval } from 'rxjs';
import { take, map } from 'rxjs/operators';
import { Settings } from '../shared/navigation/pages.model';
import { utils } from '../shared/helpers/utils';
import { DatePipe } from '@angular/common';
import SwiperCore, { Navigation, Thumbs, Swiper, SwiperOptions, Zoom } from "swiper";
import { SwiperComponent } from 'swiper/angular';
import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { AvailabilityPipe } from '../shared/pipes/availability.pipe';
import { OfferCreateDialogComponent } from './offer-create.dialog.component';
SwiperCore.use([Navigation, Thumbs, Zoom]);

@Component({
  selector: 'app-offer-details',
  templateUrl: 'offer-details.component.html',
  styleUrls: ['offer-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [DatePipe, AvailabilityPipe]
})

export class OfferDetailsComponent implements OnInit, OnDestroy {

  public isMobile = true;
  public path_configurator = '/';
  public path_offer_details = '/';
  public path_collections = '/';
  public path_dealers = '/';
  public role = 'client';
  public settings: Settings;
  public menu: any[] = [];
  public path: string;
  public path_variant = 0;
  public path_configuration: number[] = [];
  public pathparts: string[] = [];
  public pageTitle: string;
  public pageContent: string;
  public stickyTopContentColumn = 0;
  public product: Product = new Product();
  public product_additional_cost = 0;
  public discounts: Discount[];
  public products: any[];
  public products_similiar: any[];
  public attributes = [];
  public quantity = 1;
  public aboutVisible = 'collapsed';
  public manufacturerVisible = 'collapsed';
  public selectedVariant: ProductVariant;
  public selectedVariantOriginal: ProductVariant;
  public selectedVariantName = '';
  public selectedVariantVisibleAttrs = [];
  public selectedAttribute = [];
  public selectedAdditionalAttribute = [];
  public priceChangeLoading:BehaviorSubject<boolean> = new BehaviorSubject(false);
  public configurationChanged = true;
  public visibleAttribute = [];
  public variantsFlatMap = [];
  public cdn = environment.cdn;
  public api = environment.api;
  public dimensionUnits = dimensionUnits;
  public videoUrl: any;
  public model: any = [];
  public loading = false;
  public laodingSpecsheet = false;
  public collections: Collection[];
  public sub: Subscription = null;
  public sub1: Subscription = null;
  public sub2: Subscription = null;
  public sub3: Subscription = null;
  public sub4: Subscription = null;
  public isLoggedIn = false;
  public id_client = 0;
  public random_ppl = Math.floor(Math.random() * 15) + 5;

  public decoder_visible = false;
  
  public extra_field_1 = '-';
  public extra_field_2 = '-';
  public extra_field_3 = '-';
  public extra_field_4 = '-';
  public extra_field_5 = '-';

  public configure = false;
  public vdi = false;

  public thumbsSwiper: any;
  public config: SwiperOptions = {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 0,
    navigation: true,
    rewind: true,
  };

  public pagination = {
    clickable: true,
    renderBullet: function (index, className) {
      return '<span class="' + className + '"></span>';
    },
  };

  @ViewChild('swiper', { static: false }) swiper?: SwiperComponent;
  @ViewChild('productContent', {static: true}) productContent: ElementRef;
  

  constructor(@Inject(LOCALE_ID) public localeId: string, @Inject(DEFAULT_CURRENCY_CODE) private currency: string, private route: ActivatedRoute, private router: Router, private cartService: CartService, private sanitization: DomSanitizer,
    private navigationService: NavigationService, private offerService: OfferService, private utilsService: UtilsService, private datePipe: DatePipe, private availibilityPipe: AvailabilityPipe,
    private auth: AuthService, private renderer: Renderer2, private cdr: ChangeDetectorRef, public viewRef: ViewContainerRef,
    @Inject(PLATFORM_ID) private platformId: Object,  private breakpointObserver: BreakpointObserver) {
      this.breakpointObserver
      .observe(['(min-width: 1279px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.isMobile = false;
          this.cdr.markForCheck();
          // Viewport is 500px or over!
        } else {
          this.isMobile = true;
          this.cdr.markForCheck();
          // Viewport is getting smaller!
        }
      });
      this.path_offer_details = this.router.config.find(x => x.data?.module === 'OfferDetailsModule')?.data.path || '/';
      this.path_collections = this.router.config.find(x => x.data?.module === 'CollectionsModule')?.data.path || '/';
      this.path_dealers = this.router.config.find(x => x.data?.module === 'DistributorsModule')?.path || '/';
  }

  ngOnInit() {

    if (isPlatformBrowser(this.platformId)) {
      this.role = localStorage.getItem('user_role') || 'client';
    }
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.path = params.get('path');
      this.path_variant = +params.get('variant') || 0;
      if (params.get('configuration')) {
        this.path_configuration = params.get('configuration').split(',').map( Number );
      }
      this.product = null;
      const tempProduct = new Product();
      tempProduct.id = -1;
      this.products = Array(8).fill(tempProduct);
      this.products_similiar = Array(8).fill(tempProduct);
      this.attributes = [];
      this.selectedAttribute = [];
      this.selectedAdditionalAttribute = [];
      this.visibleAttribute = [];
      this.variantsFlatMap = [];
      this.selectedVariantVisibleAttrs = [];
      this.selectedVariant = null;
      this.selectedVariantName = '';
      this.product_additional_cost = 0;

      this.product = new Product();
      this.product.id = 0;
      this.product.title = '&nbsp;';
      this.product.content = '&nbsp;<br>&nbsp;';
      this.selectedVariant = new ProductVariant();
      this.selectedVariant.sku =  '&nbsp;';
      this.selectedVariant.quantity_to_add = 1;
      this.selectedVariant.price_promo = 0;
      this.extra_field_1 = '-';
      this.extra_field_2 = '-';
      this.extra_field_3 = '-';
      this.extra_field_4 = '-';
      this.extra_field_5 = '-';

      this.cdr.detectChanges();
      this.loadData();
    });

    this.pageTitle = this.route.snapshot.data.name;
    this.pageContent = this.route.snapshot.data.content;
  
    this.sub = this.cartService.discounts$.subscribe(discounts => {
      this.discounts = discounts || [];
      // if (this.product) {
      //   this.setDiscount();
      // }
      this.cdr.detectChanges();
    }, error => {
      //error
    });

    this.sub1 = this.auth.isLoggedIn.subscribe((state: UserState) => {
      this.isLoggedIn = state.logged;
      this.id_client = state.id;
    });

    this.sub2 = this.navigationService.navigation.subscribe((menu: any) => {
      if (Object.keys(menu.menu).length) {
        this.menu = menu.menu;
        this.settings = menu.settings;
        this.cdr.detectChanges();
      }
    });

    // this.sub3 = this.navigationService.mobile.subscribe(isMobile => {
    //   this.isMobile = isMobile;
    //   // if (this.isMobile) {
    //   //   this.config.freeMode = false;
    //   //   this.config.direction = 'horizontal';
    //   //   this.config.slidesPerView = 1;
    //   //   this.config.spaceBetween = 0;
    //   // } else {
    //   //   this.config.freeMode = true;
    //   //   this.config.direction = 'vertical';
    //   //   this.config.slidesPerView = 'auto';
    //   //   this.config.spaceBetween = 16;
    //   // }
    //   // this.swiper.swiperRef.destroy();
    //   // this.swiper.swiperRef.changeDirection(this.config.direction, true);
    //   // this.swiper.swiperRef.update();
    //   // this.swiper.updateOnWindowResize()

    // });


  }

  elementObserver() {
    var ro = new ResizeObserver(entries => {
      for (let entry of entries) {
        const cr = entry.contentRect;
        const t = entry.target as HTMLElement;;
        // console.log('Element:', entry.target);
        // console.log(`Element size: ${cr.width}px x ${cr.height}px`);
        // console.log(`Element padding: ${cr.top}px ; ${cr.left}px`);
        // console.log(`Element size:`, cr);
        // console.log(cr.height, window.innerHeight, t.offsetTop, window.innerHeight - t.offsetTop, cr.height - (window.innerHeight - t.offsetTop));
        // console.log($event);
        // (window.innerHeight - t.offsetTop);

        // 1730 
        // 936
        // 200
        this.stickyTopContentColumn = -(cr.height - window.innerHeight);
        this.cdr.detectChanges();
      }
    });

    // Element for which to observe height and width 
    ro.observe(this.productContent.nativeElement);
  }

  search (tree, value, key = 'id', reverse = false) {
    const stack = [...tree];
    while (stack.length) {
      const node = stack[reverse ? 'pop' : 'shift']();
      if (node[key] === value) return node;
      node.children && stack.push(...node.children);
    }
    return null;
  }

  getDelivery(id: number) {
    switch (+id) {
      case 1: {
        return '<span class="green">24H</span>';
      }
      case 2: {
        const t = $localize `24H po dostawie towaru`;
        return '<span class="red">'+t+'</span>';
      }
      case 3: {
        return '<span class="green">48H</span>';
      }
      case 4: {
        const t = $localize `48H po dostawie towaru`;
        return '<span class="red">'+t+'</span>';
      }
      case 5: {
        return '<span class="green">72H</span>';
      }
      case 6: {
        const t = $localize `72H po dostawie towaru`;
        return '<span class="red">'+t+'</span>';
      }
      default: {
        const t = $localize `15 do 30 dni roboczych`;
        return '<span class="green">'+t+'</span>';
      }
    }
  }

 
  loadData() {
    this.offerService.item(this.path, this.path_variant).pipe(take(1)).subscribe(product => {
      this.navigationService.currentPage.next(product);
      const groups = [];
      const allAttrs = [];
      let first = true;
      // let pathparts = [];
      // if (product.path2) {
      //   this.pathparts = [...product.path1.split('_'), ...product.path2.split('_')];
      // } else {
      //   this.pathparts = [...product.path1.split('_')];
      // }
      this.pathparts = [...product.path.split('_')];
      const pathpartsSec = this.path.split('_');


      product.variants.forEach((variant) => {
 
        // get all attr id for flat map key
        let id_parent = 0; // base id
        variant.quantity_to_add = 1;

        const testmap = [];
        for (let i = 0; i < variant.attributes.length; i++) {
          testmap.push(variant.attributes[i].value_real);
          if (allAttrs.findIndex(x => x.value_real === variant.attributes[i].value_real) === -1) {
            allAttrs.push({
              ord: variant.attributes[i].ord,
              value_text: variant.attributes[i].value_text,
              value_real: variant.attributes[i].value_real,
              title: variant.attributes[i].title,
              title_safe: variant.attributes[i].title_safe,
              id_attribute_variant: variant.attributes[i].id_attribute_variant,
              id_variant: 'c' + variant.id,
              type: variant.attributes[i].type,
              photos_directory: variant.attributes[i].photos_directory,
              filename: variant.attributes[i].filename,
            });
          }
        }

        if (this.pathparts.every(r => testmap.includes(r))) {
          const tax = variant.tax / 100;
          this.product.price = +product.price;
          this.product.price_promo = +product.price_promo;
          // first = false;
        }

        // if (product.photos.length && this.path_variant > 0) {
        //   console.log(product);
        //   // product.photos = product.photos.filter(p => +p.id == +this.path_variant);
        //   // variant.photo = product.photos[0].filename;
        // }

        // if(variant.photo_id) {
        //   variant.photo = product.photos.find(p => +p.id == +variant.photo_id)?.filename;
        // } else {
        //   if (product.photos.length) {
        //     variant.photo = product.photos[0].filename;
        //   }
        // }

        // console.log(variant);

        allAttrs.sort((a, b) => (a.ord > b.ord) ? 1 : ((b.ord > a.ord) ? -1 : 0));
      });

      if (this.path_variant) {
        this.selectedVariant = product.variants.find(x => +x.id === +this.path_variant);
      } else {
        this.selectedVariant = product.variants[0];
      }
      this.selectedVariantOriginal = {...this.selectedVariant};
      // if (first) { // select initial values and set visible attributes
      //   const tax = product.variants[0].tax / 100;
      //   this.selectedVariant = product.variants.find(x => +x.id === +product.variant_id)
      //   first = false;
      // }

      this.selectedVariantVisibleAttrs = this.selectedVariant.attributes.filter(a => a['id_attribute'] == 9 || a['id_attribute'] == 10 || a['id_attribute'] == 12 || a['id_attribute'] == 14);
      let g = 0;
      for (let i = 0; i < allAttrs.length; i++) {

        const groupName = allAttrs[i].title;
        const groupReal = allAttrs[i].title_safe;
        if (!groups[groupName]) { // aggregate group
          groups[groupName] = [];
          g++;
        }
        const index = groups[groupName].findIndex(x => x.real === allAttrs[i].value_real);
        if (index === -1) { // if group no group attribute, add new    

          if (typeof allAttrs[i].value_real === 'string') {
            const newpath = [...pathpartsSec];
            newpath[g] = allAttrs[i].value_real;

            groups[groupName].push({
              name: allAttrs[i].value_text,
              path: newpath.join('_'),
              real: allAttrs[i].value_real,
              id_attribute_variant: allAttrs[i].id_attribute_variant,
              photos_directory: allAttrs[i].photos_directory,
              filename: allAttrs[i].filename,
              // id_parent: [id_parent],
              type: allAttrs[i].type,
              grreal: groupReal
            });
          }

        }
      }

      for (const gr of Object.keys(groups)) {
        if (groups[gr][0].type) { // if attributes exists

          const selected = groups[gr].find(x => this.pathparts.includes(x.real));
          if (selected) {
            if (!this.selectedAttribute[groups[gr][0].grreal]) this.selectedAttribute[groups[gr][0].grreal] = [];
            this.selectedAttribute[groups[gr][0].grreal].push({id: selected.id_attribute_variant, type: 'normal'}); // select initial values
            this.selectedVariantName += selected.name + ', ';
          } else {
            // if (!this.selectedAttribute[groups[gr][0].grreal]) this.selectedAttribute[groups[gr][0].grreal] = [];
            this.selectedAttribute[groups[gr][0].grreal] = {id: groups[gr][0].id_attribute_variant, type: 'normal'};
          }
          // this.attributes.push({ name: gr, real: groups[gr][0].grreal, type: groups[gr][0].type, additional: 'normal', attrs: groups[gr] });
       
        }
      }


      // add in attributes_categories
      if (product.category_attributes) {
     
        //set default values
        product.category_attributes.forEach(x => {
          let values = [];
          x.attrs.forEach(a => {
            let default_attr_value = false;
            default_attr_value = a.extra_field_1 ? a.extra_field_1 : {segment: 3, segment_2: 2, value: false};
            if (default_attr_value['value'] != false) {
              values.push(default_attr_value['value']);
            }

            if (this.path_configuration.includes(a.id_attribute_variant)) {

              let price =  +a.price || 0;
              let tax = a.tax || 0;

              this.selectedAdditionalAttribute[x.real] = {id: a.id_attribute_variant, type: 'category', price: price, tax: tax, value: default_attr_value};
              this.configurationChanged = true;
            } else if (a.default) {
              this.selectedAdditionalAttribute[x.real] = {id: a.id_attribute_variant, type: 'category', value: default_attr_value};
            }
          });
          if (this.selectedAdditionalAttribute[x.real]) {
            this.selectedAdditionalAttribute[x.real].values = values;
          }

          // this.selectedAdditionalAttribute[x.real] = {id: x.attrs[0].id_attribute_variant, type: 'category', value: default_attr_value};
          
        });


        this.attributes = [...this.attributes, ...product.category_attributes];
      }

      // let last_type = -1;
      // product.related.forEach(related => {
        
      //   // diff of related and current
      //   const gr = related.categories[related.categories.length-1];
      //   const index = this.attributes.findIndex(x => x.real === gr.id_page+'_'+related.relation_type);
      //   if (index > -1) {
      //     this.attributes[index].attrs.push({id_attribute_variant: related.variant_id, name: related.title, path: related.path, real: related.path, product: related});
      //   } else {

      //     //SECTION HEADER
      //     if (last_type < +related.relation_type) {
      //       this.attributes.push({ name: (+related.relation_type == 0 ? $localize `Wymień elementy podstawowe` : $localize `Zamontuj dodatkowe akcesoria`), real: gr.id_page+'_'+related.relation_type, type: related.relation_type, additional: 'header', attrs: [] }); 
      //       last_type = +related.relation_type;
      //     }

      //     //FIRST ELEMENT OF SECTION
      //     const gr_values = [
      //       {id_attribute_variant: 0, name: (+related.relation_type == 0 ? $localize `Wersja standardowa` : $localize `Dodaj akcesorium`), path: '', real: '', product: null},
      //       {id_attribute_variant: related.variant_id, name: related.title, path: related.path, real: related.path, product: related},
      //     ];
      //     this.attributes.push({ name: gr.name, real: gr.id_page+'_'+related.relation_type, type: related.relation_type, additional: 'product', attrs: gr_values });
      //   }
        
      // });
     
      if (!Array.isArray(product.json_content_2)) {
        product.json_content_2 = JSON.parse(product.json_content_2);
      }
      if (!Array.isArray(product.json_content_3)) {
        product.json_content_3 = JSON.parse(product.json_content_3);
      }

      // if (isPlatformBrowser(this.platformId)) {
      //   //find iframe
      //   const parser = new DOMParser();
      //   const doc = parser.parseFromString(product.content, "text/html");
      //   const videotag = doc.querySelector("iframe");


      //   if (videotag) {
      //     this.videoUrl = this.sanitization.bypassSecurityTrustResourceUrl(videotag.src);
      //   } else {
      //     this.videoUrl = false;
      //   }

      //   if (product.extra_content_1) {
      //     this.videoUrl = this.sanitization.bypassSecurityTrustResourceUrl(product.extra_content_1);
      //   }
      // }

      this.model = product.photos.filter((x: ProductPhoto) => +x.model === 1) || [];
      product.photos = product.photos.filter((x: ProductPhoto) => +x.model !== 1) || [];

      if (+product.availability == 6) {
        if (this.selectedVariant.quantity <= 0) {
          product.delivery = 2;
        }
      }
      if (+product.availability == 4) {
          product.delivery = 2;
      }


      const unit = dimensionUnits.find(x => +x.value === +product.dimension_units)?.viewValue || '';
      product.search_attributes.push({title: 'EAN', value_text: this.selectedVariant.ean});
      // if(product.diameter_product && product?.diameter_product > 0) product.search_attributes.unshift({title: $localize `Średnica`, value_text: product.diameter_product +' '+ unit});
      // if(product.width_product && product?.width_product > 0) product.search_attributes.unshift({title: $localize `Szerokość`, value_text: product.width_product + unit});
      // if(product.length_product && product?.length_product > 0) product.search_attributes.unshift({title: $localize `Długość`, value_text: product.length_product + unit});
      // if(product.height_product && product?.height_product > 0) product.search_attributes.unshift({title: $localize `Wysokość`, value_text: product.height_product + unit});

      this.product = product;

      if (this.configurationChanged && +product.configurable == 1) {
        this.updateCode();
        this.updatePrice();
      }

      this.setMeta();

      // ANALYTICS
      if (isPlatformBrowser(this.platformId)) {

        const discounted_price = (this.selectedVariant.price_promo ? this.selectedVariant.price_promo : this.selectedVariant.price);

        // this.product.price_promo = +discounted_price;
        if ((<any>window).dataLayer) {

          let item = {
            item_name: this.product.title,
            item_id: this.product.variant_id.toString(),
            price: discounted_price,
            item_brand: this.product.manufacturer.name,
            item_variant: this.selectedVariantName.slice(0, -2),
            quantity: this.selectedVariant.quantity_to_add
          };

          (<any>window).dataLayer.push({ ecommerce: null });
          this.product.categories.forEach((c: any, i) => {
            if (c.name !== 'ROOT') {
              item['item_category' + (i > 0 ? i : '')] = c.name;
            }
          });
          (<any>window).dataLayer.push({
            event: 'view_item',
            ecommerce: {
              items: [item]
            }
          });

        }
        // this.elementObserver();
      }

      this.getRelated();
      this.getSimiliar();
      this.cdr.detectChanges();

    }, error => {
      if (error.status === 404) {
        this.router.navigate(['404']);
      } else {
        //  //error
      }
    });
  }

  changeVariant(variant_id: number) {
    this.selectedVariant = this.product.variants.find(x => +x.id === +variant_id);
    this.router.navigate(['/', this.path_offer_details, this.path, variant_id], {});
    // this.cdr.detectChanges();
  }

  compareFn(c1: any, c2: any): boolean {
    //for good selection - compare id with selected attr object
    return c1 && c2 ? +c1.id_attribute_variant === +c2 : c1 === c2;
  }

  attrButtonChange(value: any, from: string, type: string) {
    if (type == 'normal'){
      this.selectedAttribute[from] = {id: value.id_attribute_variant, type: type};
    } else {
      this.selectedAdditionalAttribute[from] = {id: value.id_attribute_variant, type: type, price: +value?.product.price || 0,  tax: +value?.product.tax || 0, value: 0};
      // update price
    }
    this.updateCode();
    this.updatePrice();
    this.configurationChanged = true;
    this.cdr.detectChanges();
  }

  attrSelectChange(i: number, event: MatSelectChange, from: string, type: string) {
    // console.log(event, from, type);
    if (+event.value.id_attribute_variant === 0) {
      delete this.selectedAdditionalAttribute[from];
    }else{

      let price = 0;
      let tax = 0;
      if (type == 'product') {
        price = +event.value?.product?.price || 0;
        tax = event.value?.product?.tax || 0;
      } else {
        price = +event.value?.price || 0;
        tax = event.value?.tax || 0;
      }
      let values = this.attributes[i].attrs.map(v => v.extra_field_1?.value).filter(Boolean);
      const selected_attr_value = event.value.extra_field_1 ? event.value.extra_field_1 : {segment: 3, segment_2: 2, value: false};
      this.selectedAdditionalAttribute[from] = {id: +event.value.id_attribute_variant, type: type, price: price, tax: tax, value: selected_attr_value, values: values};
    }
    this.updateCode();
    this.updatePrice();
    this.configurationChanged = true;
    this.cdr.detectChanges();
  }

  updateCode() {

    // console.log('UPDATE CODE', this.selectedVariant.sku, this.selectedAdditionalAttribute);

    this.product.extra_1 = utils.updateCode(this.selectedVariant.sku, this.selectedAdditionalAttribute);
    this.decoder_visible = false;
  }

  updatePrice() {
    // update price
    this.priceChangeLoading.next(true);
    this.product_additional_cost = 0;
    for (const [key, attr] of Object.entries(this.selectedAdditionalAttribute)) {
      if (attr.price) {
        this.product_additional_cost += +attr.price;
      }
    }

    let variant = {...this.selectedVariantOriginal};
    variant.price = +this.selectedVariantOriginal.price + +this.product_additional_cost;

    if (variant.price_promo > 0) {
      variant.price_promo = +this.selectedVariantOriginal.price_promo + +this.product_additional_cost;
    }
    this.offerService.price(variant).subscribe(variant_calculated => {
      this.selectedVariant.price = variant_calculated.price;
      this.selectedVariant.price_promo = variant_calculated.price_promo;
      this.cdr.markForCheck();
      this.priceChangeLoading.next(false);
    }); 
    // console.log(this.product_additional_cost, this.selectedAdditionalAttribute);
  }
 
  getSimiliar() {
    if (this.product?.categories?.length) {
      this.offerService.items({exclude: this.product.id, category: this.product.categories[this.product.categories.length - 1].id_page, limit: 9 }).pipe(take(1)).subscribe(products => {
        this.products_similiar = products.items || [];
        this.cdr.detectChanges();
      }, error => {
        //error
      });
    }
  }

  getRelated() {
    if (this.product.related?.length) {
      this.products = this.product.related;
      this.cdr.detectChanges();
    } else {
      this.products = [];
      // this.offerService.items({exclude: this.product.id, series: this.product.series, limit: 48 }).pipe(take(1)).subscribe(products => {
      //   if (products?.items) {
      //     this.products = products.items;
      //   } else {
      //     this.products = [];
      //   }
      //   this.cdr.detectChanges();
      // }, error => {
      //   //error
      // });
    }
    // const ids = this.product.search_attributes.map(a => a.id_attribute_variant);
    
  }

  getCollections() {
    this.offerService.collections({})
      .pipe(take(1))
      .subscribe(collection => {
        this.collections = collection.items || null;
        this.cdr.detectChanges();
      }, error => {
        console.log(error);
      });

  }

  changeQuantity($event: any, variant: ProductVariant) {
    // if (+$event.target.value > this.product.variants[0].quantity) {
      // variant.quantity_to_add = this.product.variants[0].quantity;
    // } else 
    if (+$event.target.value < 0) {
      variant.quantity_to_add = 1
    } else {
      variant.quantity_to_add = $event.target.value;
    }
  }

  plus(variant: ProductVariant) {
    if (!variant.quantity_to_add) variant.quantity_to_add = 1;
    variant.quantity_to_add++;
    this.cdr.detectChanges();
  }

  minus(variant: ProductVariant) {
    if (!variant.quantity_to_add) variant.quantity_to_add = 1;
    if (variant.quantity_to_add > 1) {
      variant.quantity_to_add--;
      this.cdr.detectChanges();
    }
  }

  addToFavorites() {
    //...Object.values(this.selectedAttribute), 
    let attributes = [...Object.values(this.selectedAdditionalAttribute)];
    this.cartService.addToFavorites(this.selectedVariant.id, (this.product.extra_1 != this.product.series ? this.product.extra_1 : null), attributes);
  }

  addToCart() {

    let supply = $localize `Przewidywana dostawa: nieznana`;
    if (this.selectedVariant.date_supply && this.selectedVariant.quantity <= 10 && this.isLoggedIn && this.role == 'client_b2b'){
      supply = $localize `Przewidywana dostawa: ` + this.datePipe.transform(this.selectedVariant.date_supply, 'shortDate');
    } else {
      supply = $localize `Przewidywana dostawa: ` + this.availibilityPipe.transform(this.product.availability, this.role, this.selectedVariant.quantity, this.product.availability_txt);
    }
    

    let cartAttributes = [];
    if (this.configurationChanged) {
      // cartAttributes = [...Object.values(this.selectedAttribute), ...Object.values(this.selectedAdditionalAttribute)];
      cartAttributes = [...Object.values(this.selectedAdditionalAttribute)];
    } else {
      cartAttributes = [];
    }

    // console.log([...this.selectedAttribute, ...Object.values(this.selectedAdditionalAttribute)]);

    let moded_price = (this.product_additional_cost > 0 ? (this.selectedVariant.price_promo > 0 ? this.selectedVariant.price_promo : this.selectedVariant.price) : null);
    // if (+this.selectedVariant.price_promo > 0 && +this.selectedVariant.price_promo < +this.selectedVariant.price) {
    //   moded_price = (this.product_additional_cost > 0 ? this.selectedVariant.price_promo : null);
    // }

    this.cartService.add(this.product.id, this.selectedVariant.id, this.selectedVariant.quantity_to_add, cartAttributes, this.product.availability, false, supply, this.product.extra_1, this.product.extra_2, this.product.extra_3, this.product.extra_4, moded_price);
    // ANALYTICS
    if (isPlatformBrowser(this.platformId)) {

      if ((<any>window).dataLayer) {

        const discounted_price = (this.selectedVariant.price_promo ? this.selectedVariant.price_promo : this.selectedVariant.price);
        let item = {
          item_name: this.product.title,
          item_id: this.product.variant_id.toString(),
          price: discounted_price,
          item_brand: this.product.manufacturer.name,
          item_variant: this.selectedVariantName.slice(0, -2),
          quantity: this.selectedVariant.quantity_to_add,
          id: this.product.id.toString(),
          google_business_vertical: 'retail'
        };

        (<any>window).dataLayer.push({ ecommerce: null });
        this.product.categories.forEach((c: any, i) => {
          if (c.name !== 'ROOT') {
            item['item_category' + (i > 0 ? i : '')] = c.name;
          }
        });
        (<any>window).dataLayer.push({
          event: 'add_to_cart',
          ecommerce: {
            items: [item]
          }
        });

        // //old
        // let universal_item = {
        //   name: this.product.title,
        //   id: this.product.id.toString(),
        //   price: discounted_price,
        //   brand: this.product.manufacturer.name,
        //   category: (this.product.categories.length > 0 ? this.product.categories[this.product.categories.length - 1].name : ''),
        //   variant: this.selectedVariantName.slice(0, -2),
        //   quantity: this.selectedVariant.quantity_to_add
        // };
        // (<any>window).dataLayer.push({ ecommerce: null });
        // (<any>window).dataLayer.push({
        //   'event': 'addToCart',
        //   'ecommerce': {
        //     'currencyCode': this.currency,
        //     'add': {
        //       'products': [universal_item]
        //     }
        //   }
        // });
      }
    }

    this.cdr.detectChanges();
  }

  addRelatedToCart(product: Product) {
    let supply = $localize `Przewidywana dostawa: nieznana`;
    if (product.variants[product.variant_selected].date_supply && product.variants[product.variant_selected].quantity <= 10 && this.isLoggedIn && this.role == 'client_b2b'){
      supply = $localize `Przewidywana dostawa: ` + this.datePipe.transform(product.variants[product.variant_selected].date_supply, 'shortDate');
    } else {
      supply = $localize `Przewidywana dostawa: ` + this.availibilityPipe.transform(product.availability, this.role, product.variants[product.variant_selected].quantity, product.availability_txt);
    }
    this.cartService.add(product.id, product.variants[product.variant_selected].id, product.variants[product.variant_selected].quantity_to_add, [], product.availability, false, supply, product.extra_1, product.extra_2, product.extra_3, product.extra_4);
    this.cdr.detectChanges();
  }

  openAskDialog(): void {
    this.navigationService.showFacebookChatDialog()
  }

  setMeta() {

    this.navigationService.setMeta(
      this.product.meta_title ? this.product.meta_title : this.product.title,
      this.product.meta_keywords ? this.product.meta_keywords : this.product.title,
      this.product.meta_description ? this.product.meta_description : this.product.summary.replace(/<\/?("[^"]*"|'[^']*'|[^>])*(>|$)/g, ''),
      environment.base + '/'+this.path_offer_details+'/' + this.product.path
    );

  }

  downloadFiles() {
    this.product.categories.forEach(category => {
      if (+category.level == 3) {
        console.log(category)
      }
    })
  }

  getSpecsheet(type: string){

    this.laodingSpecsheet = true;
    this.cdr.detectChanges();

    let prepared_data = {
      id: this.product.id,
      id_variant: this.selectedVariant.id,
      id_manufacturer: this.product.manufacturer.id,
      lang: this.localeId,
      currency: this.selectedVariant.currency,
      page_url: this.router.url,
      id_client: null,
      sku: this.product.extra_1 ? this.product.extra_1 : this.selectedVariant.sku,
      price: +this.selectedVariant.price,
      price_extra: this.product_additional_cost,
      configuration: {},
      related: [],
      expiration_date: null,
      modified_percent: null,
      modified_price: null,
      comment: null,
      comment_sec: null,
      tax: +this.selectedVariant.tax,
      tax_type: false
    };

    for (const [key, attr] of Object.entries(this.selectedAdditionalAttribute)) {
      prepared_data.configuration[attr.id] = attr.value.value;
    }

    if (type == 'complex') {

    const dialogResponse = new Subject<any>();
      this.utilsService.openDialog({
        childComponent: OfferCreateDialogComponent,
        data: {product: prepared_data, related: this.product.related},
        closeDialogSubject: dialogResponse
      });

      dialogResponse.subscribe(data => {
        if (data.action == 'generate') {
          this.utilsService.setLoading();
          
          prepared_data.id_client = this.id_client;
          prepared_data.expiration_date = data.expiration_date;
          prepared_data.modified_percent = data.modified_percent;
          prepared_data.modified_price = data.modified_price;
          prepared_data.comment = data.comment;
          prepared_data.related = data.related;
          prepared_data.comment_sec = data.comment_sec;
          prepared_data.tax = data.tax;
          prepared_data.tax_type = data.tax_type;
      
          this.offerService.specsheet(prepared_data).subscribe({
            next: url => {
              this.utilsService.clearLoading();
              this.laodingSpecsheet = false;
              this.cdr.detectChanges();
              window.open(this.cdn + '/' + url, '_blank');
            },
            error: error => {
              this.utilsService.openDialog({
                isSnackbar: 'error',
                content: $localize `Wystąpił błąd, spróbuj jeszcze raz`,
                actionButtons: [{ text: 'OK', onAction: () => true}],
              });
          }});
        } else {
          this.utilsService.clearLoading();
          this.laodingSpecsheet = false;
          this.cdr.detectChanges();
        }
      });

    } else {
      this.utilsService.setLoading();
      this.offerService.specsheet(prepared_data).subscribe({
        next: url => {
          this.utilsService.clearLoading();
          this.laodingSpecsheet = false;
          this.cdr.detectChanges();
          window.open(this.cdn + '/' + url, '_blank');
        },
        error: error => {
          this.utilsService.openDialog({
            isSnackbar: 'error',
            content: $localize `Wystąpił błąd, spróbuj jeszcze raz`,
            actionButtons: [{ text: 'OK', onAction: () => true}],
          });
      }});
    }
  }
  
  toggleDecoder() {
    this.decoder_visible = !this.decoder_visible;
    navigator.clipboard.writeText(this.product.extra_1 ? this.product.extra_1 : this.selectedVariant.sku);
  }

  copyCode() {
    navigator.clipboard.writeText(this.product.extra_1 ? this.product.extra_1 : this.selectedVariant.sku);
    this.utilsService.openDialog({
      isSnackbar: 'success',
      content: $localize `Kod towaru został skopiowany`,
      actionButtons: [{ text: 'OK', onAction: () => true}],
    });
  }

  openGallery() {

    const dialogResponse = new Subject<any>();

    dialogResponse.subscribe(data => {
    });

    this.utilsService.openDialog({
      childComponent: 'LazyLightboxComponent',
      closeDialogSubject: dialogResponse,
      data: this.product.photos
    }, this.viewRef);
  }
  
  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
    if (this.sub1) {
      this.sub1.unsubscribe();
    }
    if (this.sub2) {
      this.sub2.unsubscribe();
    }
    if (this.sub3) {
      this.sub3.unsubscribe();
    }
    if (this.sub4) {
      this.sub3.unsubscribe();
    }
  }

}
